import React from 'react';
import { withTheme } from 'styled-components';
export var PlayIcon = function PlayIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    version: "1.1"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "playIcon-Copy-3",
    transform: "translate(1.000000, 1.000000)"
  }, React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: "2",
    fill: theme.colors.primary,
    fillRule: "nonzero",
    cx: "28",
    cy: "28",
    r: "28"
  }), React.createElement("path", {
    d: "M20.8973333,15.1955222 C21.3135222,14.9683333 21.8206333,14.9864556 22.2194778,15.2428889 L40.3676778,26.9095556 C40.7386778,27.1481 40.9629889,27.5589222 40.9629889,28 C40.9629889,28.4410778 40.7386778,28.8519 40.3676778,29.0903667 L22.2194778,40.7570333 C21.8206333,41.0134667 21.3135222,41.0316667 20.8973333,40.8044 C20.4811444,40.5772111 20.2222222,40.1408778 20.2222222,39.6666667 L20.2222222,16.3333333 C20.2222222,15.8591222 20.4811444,15.4227889 20.8973333,15.1955222 Z M22.8147889,18.7077333 L22.8147889,37.2922667 L37.2694778,28 L22.8147889,18.7077333 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))));
};
export default withTheme(PlayIcon);